{
  "shared": {
    "names": "Names",
    "startDate": "Start Date",
    "endDate": "End Date",
    "pit": "Pit",
    "bucketType": "Bucket Type",
    "plantType": "Plant Type",
    "searchForPit": "Search for Pit",
    "searchForMaterialType": "Search for Material Type",
    "selectBucketType": "Select Bucket Type",
    "isLive": "Is Live",
    "scopeBlankHint": "Scope (blank = everyone but contractors)",
    "unset": "Unset",
    "unsetParenthesised": "(Unset)",
    "noneSelected": "None selected",
    "geofence": "Geofence",
    "geofencePolygon": "Polygon",
    "geofenceSet": "Set",
    "geofenceSaved": "Geofence saved"
  },
  "validation": {
    "nameRequired": "Name is required",
    "plantRequired": "Plant is required",
    "bucketTypeRequired": "Bucket Type is required",
    "dateFromRequired": "Date From is required",
    "dateFromBeforeDateTo": "Date From must be set earlier than Date To",
    "startDateRequired": "Start Date is required",
    "startDateBeforeEndDate": "Start Date must be set earlier than End Date"
  },
  "analytes": {
    "rangeFrom": "Range From",
    "rangeTo": "Range To",
    "editTitle": "Edit Analyte",
    "filterPlaceholder": "Filter by Analyte name",
    "rangeFromRequired": "Range From is required",
    "rangeToRequired": "Range To is required",
    "rangeFromBelowRangeTo": "Range From must be less than Range To",
    "added": "Analyte added successfully",
    "deleted": "Analyte deleted successfully",
    "confirmDelete": "Are you sure you want to delete this Analyte? This action cannot be undone."
  },
  "blastMaterials": {
    "materialType": "Blast Material Type",
    "live": "Live",
    "materialTypesLoadFailed": "Error while fetching the material types options.",
    "materialTypeRequired": "Blast material type must be chosen",
    "added": "Blast material added successfully",
    "updated": "Blast material updated successfully",
    "deleted": "Blast material deleted successfully"
  },
  "blastMaterialTypes": {
    "decimalPlaces": "Decimal Places",
    "measurementType": "Measurement Type",
    "sortOrder": "Sort Order",
    "measurementTypeTooLong": "Measurement Type can be at most 10 characters",
    "sortOrderRequired": "Sort order is required",
    "added": "Blast material type added successfully",
    "updated": "Blast material type updated successfully",
    "deleted": "Blast material type deleted successfully"
  },
  "materialRegister": {
    "title": "Explosives register details",
    "unit": "Unit",
    "storageClass": "Storage class",
    "neqPerUnit": "NEQ per unit (kg)",
    "hazardDivision": "Hazard division",
    "unNumber": "UN number",
    "packSize": "Pack size",
    "shelfLife": "Shelf life (months)",
    "standardCost": "Standard cost per unit",
    "productCode": "Product code",
    "supplier": "Supplier",
    "lotTracked": "Lot tracked",
    "bulk": "Bulk (made in the MMU)",
    "save": "Save register details",
    "saved": "Register details saved"
  },
  "blastPatterns": {
    "blastBcm": "Blast BCM",
    "bcm": "BCM",
    "orePercent": "ORE %",
    "explosivesRequiredDate": "Explosives Required Date",
    "detail": "Detail",
    "openPattern": "Open",
    "filterLabel": "Blast Pattern",
    "filterPlaceholder": "Filter by Pattern Name",
    "includeCompleted": "Include Completed",
    "pitStageRequired": "Pit Stage must be chosen",
    "tonnesRequired": "Tonnes are required",
    "bcmRequired": "BCM is required",
    "orePercentRequired": "Ore percentage is required",
    "added": "Blast Pattern added successfully",
    "updated": "Blast Pattern updated successfully",
    "deleted": "Pattern blast deleted successfully"
  },
  "blastDrillings": {
    "rig": "Rig",
    "holeType": "Hole Type",
    "bitSize": "Bit Size",
    "numberOfHoles": "Number of Holes",
    "totalMetres": "Total Metres",
    "redrill": "Redrill"
  },
  "blastMaterialUsage": {
    "blastMaterial": "Blast Material",
    "quantity": "Quantity",
    "fromHoles": "Charged hole by hole, so these are added up from the Charging tab.",
    "updated": "Blast material usage updated successfully"
  },
  "bucketFactors": {
    "bucketFactor": "Bucket Factor",
    "searchForBucketType": "Search for Bucket Type",
    "searchForMaterialTypeClass": "Search for Material Type Class",
    "editTitle": "Edit Bucket Factor",
    "addTitle": "Add new Bucket Factor",
    "pitName": "Pit Name",
    "filterPlaceholder": "Filter by Bucket Type",
    "from": "From: ",
    "fromPlaceholder": "Select from date",
    "to": "To: ",
    "toPlaceholder": "Select to date",
    "includeFinished": "Include Finished",
    "bucketFactorRequired": "Bucket Factor is required",
    "dateFromBeforeDateTo": "Date From must be earlier than Date To",
    "added": "Bucket Factor added successfully",
    "updated": "Bucket Factor updated successfully",
    "deleted": "Bucket Factor deleted successfully"
  },
  "bucketTypes": {
    "editTitle": "Edit Bucket Type",
    "added": "Bucket Type added successfully",
    "updated": "Bucket Type updated successfully",
    "deleted": "Bucket Type deleted successfully"
  },
  "densities": {
    "density": "Density",
    "searchForPitStage": "Search for Pit Stage",
    "selectPitFirst": "Select a Pit first",
    "selectMaterialTypeClass": "Select Material Type Class",
    "editTitle": "Edit Density",
    "addTitle": "Add new Density",
    "addSubmit": "Add Density",
    "filterByPit": "Filter by Pit",
    "filterByMaterialType": "Filter by Material Type",
    "allClasses": "All",
    "factorRequired": "Factor is required",
    "updated": "Density updated successfully",
    "deleted": "Density deleted successfully"
  },
  "deviceMappings": {
    "intro": "Which tracker is fitted to which machine. Positions arriving from a device with no mapping here are stored but attached to no machine, so they produce no locations, stoppages or loads.",
    "deviceId": "Device Id",
    "sourceSystem": "Source System",
    "accuracy": "Accuracy",
    "ownCodes": "Own Codes",
    "reportsOwnStoppageCodes": "Reports its own stoppage codes",
    "editTitle": "Device mapping - {{deviceId}}",
    "saving": "Saving...",
    "deviceIdRequired": "Device id is required",
    "sourceSystemRequired": "Source system is required, and must match the vendor name the FMS sends",
    "machineRequired": "Choose the machine this device is fitted to",
    "added": "Device mapping added",
    "saved": "Device mapping saved",
    "deleteFailed": "Could not delete that device mapping",
    "deleted": "Device mapping deleted"
  },
  "downtimeSubtypes": {
    "subtype": "Subtype",
    "subtypeName": "Subtype Name",
    "selectStoppageType": "Select Stoppage Type",
    "editTitle": "Edit Stoppage Subtype",
    "subtypeNameRequired": "Subtype name is required",
    "loadError": "There was an error loading the subtype data, please try again",
    "stoppageTypeRequired": "Stoppage Type is required",
    "added": "Stoppage Subtype added successfully",
    "deleted": "Stoppage Subtype deleted successfully",
    "confirmDelete": "Are you sure you want to delete this Stoppage Subtype? This action cannot be undone."
  },
  "locations": {
    "locationType": "Location Type",
    "scope": "Scope",
    "geofenceCircle": "Circle",
    "showAll": "Show All",
    "locationTypesLoadFailed": "Error while fetching the location types options.",
    "locationTypeRequired": "Location type must be chosen",
    "added": "Location added successfully",
    "updated": "Location updated successfully",
    "deleted": "Location deleted successfully",
    "geofenceSaveFailed": "Could not save the geofence",
    "geofenceUnreachable": "Could not reach the server to save the geofence"
  },
  "materialTypeClasses": {
    "class": "Class",
    "classes": "Classes",
    "filterPlaceholder": "Filter by Material Type Class",
    "editTitle": "Edit Material Type Class",
    "add": "Add Material Type Class",
    "materialTypeRequired": "Material Type is required",
    "added": "Material Type Class added successfully",
    "updated": "Material Type Class updated successfully",
    "deleted": "Material Type Class deleted successfully"
  },
  "materialTypes": {
    "nameLabel": "Material Type Name",
    "isWaste": "Is Waste",
    "isLiveQuestion": "Is Live?",
    "isWasteQuestion": "Is Waste?",
    "editTitle": "Edit Material Type",
    "filterPlaceholder": "Filter by Material Type name",
    "isWasteRequired": "Is Waste is required",
    "isLiveRequired": "Is Live is required",
    "updated": "Material Type updated successfully",
    "deleted": "Material Type deleted successfully"
  },
  "minePeriods": {
    "editTitle": "Edit Period",
    "allTypes": "All",
    "nameRequired": "Name is required.",
    "datesRequired": "Date From and Date To are required.",
    "dateFromBeforeDateTo": "Date From must be before Date To.",
    "added": "Period added successfully.",
    "updated": "Period updated successfully.",
    "deleted": "Period deleted successfully.",
    "confirmDelete": "Are you sure you want to delete this period? This action cannot be undone."
  },
  "pitStages": {
    "nameLabel": "Pit Stage Name",
    "selectPit": "Select Pit",
    "editTitle": "Edit Pit Stage",
    "addTitle": "Add new Pit Stage",
    "filterPlaceholder": "Filter by Pit Stage name",
    "pitRequired": "Pit is required",
    "updated": "Pit Stage updated successfully",
    "deleted": "Pit Stage deleted successfully"
  },
  "plantTypes": {
    "nameLabel": "Plant Type Name",
    "editTitle": "Edit Plant Type",
    "filterPlaceholder": "Filter by Plant Type name",
    "added": "Plant Type added successfully",
    "deleted": "Plant Type deleted successfully"
  },
  "plants": {
    "plantName": "Plant Name",
    "primaryJobType": "Primary Job Type",
    "jobType": "Job Type",
    "shiftHours": "Shift Hours",
    "bucket": "Bucket",
    "autoCalculateEngineHours": "Auto Calculate Engine Hours",
    "autoCalculateEngineHoursQuestion": "Auto Calculate Engine Hours?",
    "addNewPlant": "Add new Plant",
    "addTitle": "Add New Plant",
    "addBucketTitle": "Add Bucket to Plant",
    "editTitle": "Edit Plant",
    "filterPlaceholder": "Filter by Plant name",
    "includeEnded": "Include Ended",
    "zoneRequired": "Zone is required",
    "plantTypeRequired": "Plant Type is required",
    "shiftHoursMustBe": "Shift Hours must be {{hours, list(type: disjunction)}}",
    "bucketDateFromRequired": "Date From is required to add a Bucket",
    "added": "Plant added successfully",
    "updated": "Plant updated successfully",
    "deleted": "Plant deleted successfully",
    "confirmDelete": "Are you sure you want to delete this Plant? This action cannot be undone."
  },
  "plantBuckets": {
    "addTitle": "Add New Plant Bucket",
    "dateToHint": "If Date To is left empty, current Bucket's Date To will be set to today.",
    "addNew": "Add new Plant Bucket",
    "invalidId": "Invalid Plant Bucket ID value",
    "added": "Plant Bucket added successfully",
    "deleted": "Plant Bucket deleted successfully",
    "parentRefreshFailed": "Failed to refresh parent row, please refresh the page"
  },
  "plantMeters": {
    "title": "Rig meters",
    "meter": "Meter",
    "recorded": "Recorded",
    "serviceInterval": "Service interval (h)",
    "lastService": "Last service",
    "suggested": "{{meter}} (suggested)",
    "lastServiceAt": "{{date}} at {{reading}} h",
    "saved": "Meter saved"
  }
}
